module.exports = __webpack_public_path__ + "static/media/sr.f6701626.svg";